module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Pro Max Midnight Green.8b444655.png";